import {
    ACTION_ADMIN_SET_USERS,
    ACTION_ADMIN_SET_CONTRACTS,
    ACTION_ADMIN_SET_TOKENS,
    ACTION_ADMIN_UPDATE_USER,
    ACTION_ADMIN_SET_SELECTED_USER,
    ACTION_CREATE_MASTER_CONTRACT,
    ACTION_SET_MASTER_CONTRACTS,
    ACTION_UPDATE_MASTER_CONTRACT,
} from '../actions/admin';

const initialState = {
    users: null,
    contracts: null,
    masterContracts: null,
    tokens: null,
};

const updateMasterContract = (payload, { masterContracts }) => {
    return masterContracts.map((contract) =>
        contract._id === payload._id ? payload : contract
    );
};

export default function admin(state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_ADMIN_SET_USERS:
            return { ...state, users: payload };
        case ACTION_ADMIN_SET_CONTRACTS:
            return { ...state, contracts: payload };
        case ACTION_CREATE_MASTER_CONTRACT:
            return {
                ...state,
                masterContracts: [...state.masterContracts, payload],
            };
        case ACTION_SET_MASTER_CONTRACTS:
            return { ...state, masterContracts: payload };
        case ACTION_ADMIN_SET_TOKENS:
            return { ...state, tokens: payload };
        case ACTION_ADMIN_UPDATE_USER:
            const users = state.users.map((user) => {
                if (user._id === payload._id) {
                    return payload;
                }

                return user;
            });

            return { ...state, users };
        case ACTION_ADMIN_SET_SELECTED_USER:
            return { ...state, selectedUser: payload };
        case ACTION_UPDATE_MASTER_CONTRACT:
            return {
                ...state,
                masterContracts: updateMasterContract(payload, state),
            };
        default:
            return state;
    }
}
